import _toConsumableArray from "/Users/alvaramat/game-dices/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export default function valueToArray(value) {
  if (!value) {
    return [];
  }

  return !Array.isArray(value) ? [value] : _toConsumableArray(value);
}